import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card } from "antd"

/**
 * creat by xcc
 * @description 批量顶部导航
 */
const { Meta } = Card;
export default class TopNavigation extends Component {
    static propTypes = {
        style: PropTypes.object,
        styleOut: PropTypes.object,
        key: PropTypes.string,
    };
    static defaultProps = {
        style: {},
        styleOut: {},
        batchTitle: '批量审核'
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
        const observer = new ResizeObserver(e => {
            e.forEach(entry=>{
                this.props.onResize(entry.target.offsetHeight);
            });
        });
        const target = document.querySelector('.topNavigation');
        target && observer.observe(target);
    }

    render() {
        const { batchTitle, goBack } = this.props;
        return (
            <div className={'topNavigation'} style={this.props.styleOut}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderRadius: "5px 5px 0px 0px"
                }}>
                    <div style={{
                        fontSize: 16,
                        fontWeight: 550,
                        color: "#222",
                        fontFamily: "Microsoft YaHei"
                    }}>{batchTitle}</div>
                    <div>当前位置：媒体管理 > <span style={{color: "#1890ff"}}>{batchTitle}</span><span
                        style={{margin: "0px 10px"}}>|</span><span onClick={() => {goBack()}} style={{
                        color: "#1890ff",
                        cursor: "pointer"
                    }}>返回上一级</span></div>
                </div>
            </div>
        )
    }

}